import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Button, TextField, Grid, Box } from "@mui/material";
import { getUserInfo, updateUserInfo, updateUserDefaultShipping } from "../service/userService";
import addressService from "../service/addressService";//{ getUserAddresses, updateAddress }
import { useAuth } from '../context/AuthContext';
import Footer from '../components/SFooter';
import Header from '../components/Header';
import SubscriptionCard from '../components/SubscriptionCard';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';
import BackToHome from "../components/BackToHome";

 
export default function ProfilePage() { 
  const { user, setUser, refreshUser  } = useAuth();
 const { t } = useTranslation();
  const [addresses, setAddresses] = useState([]);
  const [editingUser, setEditingUser] = useState(false);
  const [editingAddressId, setEditingAddressId] = useState(null);
  const [formData, setFormData] = useState({});
  const [addressFormData, setAddressFormData] = useState({});

  useEffect(() => {
    loadAddresses();
  }, []);

  const loadUserData = async () => {
     await refreshUser();
  }; 

   async function loadAddresses() {
    const data = await addressService.getUserAddresses(user.userId);
    setAddresses(data);
  }

  const handleUserEdit = () => {
    setEditingUser(true);
    setFormData({ name: user.name, givenName: user.givenName, familyName: user.familyName, email: user.email, company: user.company});
  };

  const handleUserSave = async () => {
    
    if(!formData.company || !formData.name || !formData.givenName || !formData.familyName || !formData.email){
      alert("Please fill all the details!");
      return;
    }
    
    await updateUserInfo(formData);
    setEditingUser(false);
    loadUserData();
  };
  
 const handleSetShippingAddress  = async (addressId) => {
    
  await updateUserDefaultShipping(user.userId, { addressId:addressId });
   loadAddresses();
   loadUserData();
  };

    const handleAddressNew = (id) => {
    setEditingAddressId(id);
    const addr = addresses.find(a => a.addressId === id);
    setAddressFormData({ ...addr });
  };
  const handleAddressEdit = (id) => {
    setEditingAddressId(id);
    const addr = addresses.find(a => a.addressId === id);
    setAddressFormData({ ...addr });
  };
  
    const handleAddressDelete= async  (id) => {
   
    await addressService.deleteUserAddress(user.userId,id);
       loadAddresses();
         loadUserData();
  };
  
  

  const handleAddressSave = async () => {
      
    if(!addressFormData.street1 || !addressFormData.city || !addressFormData.state || !addressFormData.country || !addressFormData.email || !addressFormData.postalCode){
      alert("Please fill all the details!");
      return;
    }
    addressFormData.userId= user.userId;
    await addressService.updateAddress(editingAddressId, addressFormData);
    setEditingAddressId(null);
    loadAddresses();
       loadUserData();
  };

  return (
        <>
      <Header />
    <Box sx={{ p: 3 }}>
<Typography variant="h4" sx={{ textAlign: 'center' }}>
   {t('my_profile' , 'My Profile')} 
</Typography>

      {/* User Info Section */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ textAlign: 'center' }}>{t('user_information' , 'User Information')} </Typography>
          {editingUser ? (
            <Box sx={{ mt: 2 }}>
            <TextField
                label="Email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                fullWidth
                     InputProps={{
                        readOnly: true,
                    }}
              />
              <TextField
                label="Name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                fullWidth
                sx={{ mb: 2 }}
              />
              <TextField
                label="Given Name"
                value={formData.givenName}
                onChange={(e) => setFormData({ ...formData, givenName: e.target.value })}
                fullWidth
                sx={{ mb: 2 }}
              />
              <TextField
                label="Family Name"
                value={formData.familyName}
                onChange={(e) => setFormData({ ...formData, familyName: e.target.value })}
                fullWidth
                sx={{ mb: 2 }}
              />
              <TextField
                label="Company Name"
                value={formData.company}
                onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                fullWidth
                sx={{ mb: 2 }}
              />
              
              <Box sx={{ mt: 2 }}>
                <Button variant="contained" onClick={handleUserSave}>{t('save' , 'Save')}</Button>
                <Button sx={{ ml: 2 }} onClick={() => setEditingUser(false)}>{t('cancel' , 'Cancel')}</Button>
              </Box>
            </Box>
          ) : (
            <>
              <Typography>Email: {user?.email}</Typography>
              <Typography>Name: {user?.name}</Typography>
              <Typography>Given Name: {user?.givenName}</Typography>
              <Typography>Family Name: {user?.familyName}</Typography>
              <Typography>Company Name: {user?.company}</Typography>
              <Button sx={{ mt: 1 }} variant="outlined" onClick={handleUserEdit}>{t('edit' , 'Edit')}</Button>
            </>
          )}
        </CardContent>
      </Card>

      {/* Address Section */}
      <Card>
        <CardContent>
        
          <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: 2, // margin-bottom to separate from the fields
    }}
  >
    <Typography variant="h6">{t('customer_address' , 'Customer Addresses')} </Typography>
    <Button
      variant="outlined"
      size="small"
      onClick={() => handleAddressNew(0)}
    >
      {t('add_address' , 'Add Address')}
    </Button>
  </Box>


             {editingAddressId === 0  ? (
             <>
                  <TextField
                    label="Street Line 1"
                    value={addressFormData.street1}
                    onChange={(e) => setAddressFormData({ ...addressFormData, street1: e.target.value })}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Street Line 2"
                    value={addressFormData.street2}
                    onChange={(e) => setAddressFormData({ ...addressFormData, street2: e.target.value })}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="City"
                    value={addressFormData.city}
                    onChange={(e) => setAddressFormData({ ...addressFormData, city: e.target.value })}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="State"
                    value={addressFormData.state}
                    onChange={(e) => setAddressFormData({ ...addressFormData, state: e.target.value })}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Zip Code"
                    value={addressFormData.postalCode}
                    onChange={(e) => setAddressFormData({ ...addressFormData, postalCode: e.target.value })}
                    fullWidth
                  />
                  
                  <TextField
                    label="Country"
                    value={addressFormData.country}
                    onChange={(e) => setAddressFormData({ ...addressFormData, country: e.target.value })}
                    fullWidth
                  />
                   <TextField
                    label="Email ID"
                    value={addressFormData.email}
                    onChange={(e) => setAddressFormData({ ...addressFormData, email: e.target.value })}
                    fullWidth
                  />
                  <TextField
                    label="Contact Number"
                    value={addressFormData.phone}
                    onChange={(e) => setAddressFormData({ ...addressFormData, phone: e.target.value })}
                    fullWidth
                  />
                      
                  <Box sx={{ mt: 2 }}>
                    <Button variant="contained" onClick={handleAddressSave}>  {t('save' , 'Save')}</Button>
                    <Button sx={{ ml: 2 }} onClick={() => setEditingAddressId(null)}> {t('cancel' , 'Cancel')}</Button>
                  </Box>
                </>
            ) : (
            <></>
            )}

          {addresses.map(addr => (
            <Box key={addr.addressId} sx={{ mt: 2, borderBottom: "1px solid #ddd", pb: 2 }}>
              {editingAddressId === addr.addressId ? (
                <>
                  <TextField
                    label="Street Line 1"
                    value={addressFormData.street1}
                    onChange={(e) => setAddressFormData({ ...addressFormData, street1: e.target.value })}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Street Line 2"
                    value={addressFormData.street2}
                    onChange={(e) => setAddressFormData({ ...addressFormData, street2: e.target.value })}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="City"
                    value={addressFormData.city}
                    onChange={(e) => setAddressFormData({ ...addressFormData, city: e.target.value })}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="State"
                    value={addressFormData.state}
                    onChange={(e) => setAddressFormData({ ...addressFormData, state: e.target.value })}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Zip Code"
                    value={addressFormData.postalCode}
                    onChange={(e) => setAddressFormData({ ...addressFormData, postalCode: e.target.value })}
                    fullWidth
                  />
                  
                  <TextField
                    label="Country"
                    value={addressFormData.country}
                    onChange={(e) => setAddressFormData({ ...addressFormData, country: e.target.value })}
                    fullWidth
                  />
                   <TextField
                    label="Email ID"
                    value={addressFormData.email}
                    onChange={(e) => setAddressFormData({ ...addressFormData, email: e.target.value })}
                    fullWidth
                  />
                  <TextField
                    label="Contact Number"
                    value={addressFormData.phone}
                    onChange={(e) => setAddressFormData({ ...addressFormData, phone: e.target.value })}
                    fullWidth
                  />
                      
                  <Box sx={{ mt: 2 }}>
                    <Button variant="contained" onClick={handleAddressSave}>{t('save' , 'Save')}</Button>
                    <Button sx={{ ml: 2 }} onClick={() => setEditingAddressId(null)}>{t('cancel' , 'Cancel')}</Button>
                  </Box>
                </>
              ) : (
                <>
                <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: 2, // margin-bottom to separate from the fields
    }}
  >
    <Typography variant="h6">{addr.state}, {addr.city}  - {addr.postalCode}  </Typography>
 {addr.selectedShippingAddress  ? (
    <Button
      variant="contained"
      size="small"
   color="inherit"
    >
     {t('current_shipping_address' , 'Current Shipping Address')} 
     
    </Button>
  ) : (
   <Button
      variant="contained"
      size="small"
      onClick={() => handleSetShippingAddress(addr.addressId)}
    >
      {t('set_as_shipping_address' , 'Set As Shipping Address')}  
    </Button>
  )}
  </Box> 
                  <Typography>{addr.street1},{addr.street2} </Typography>
                  <Typography>{addr.city}, {addr.state} - {addr.postalCode}</Typography>
                <Typography>{addr.email}</Typography>
                <Typography>{addr.phone}</Typography>
                <Button variant="outlined" size="small" sx={{ mt: 1 }} onClick={() => handleAddressEdit(addr.addressId)}>{t('edit' , 'Edit')} </Button>
                <Button variant="outlined" size="small" sx={{ mt: 1 }} onClick={() => handleAddressDelete(addr.addressId)}>{t('delete' , 'Delete')} </Button>
                </>
              )}
            </Box>
          ))}
        </CardContent>
        <CardContent>

<SubscriptionCard user={user} />
        </CardContent>
      </Card>
    </Box>

 <BackToHome />
  
      <Footer />
    </>
  );
}